//当前debug服务器url
const SERVER_URL = '/'
//api server url前缀
const SERVER_API_URL = '/'
//试题中的图片url前缀
const QUESTION_IMG_URL = 'https://hiyiba.com/downloadfile?t=100&path='
module.exports = {
  //是否是debug模块build
  DEBUG: true,

  //api server url前缀
  API_SERVER_URL: SERVER_API_URL,

  //登录页面url前缀
  LOGIN_URL: SERVER_URL + 'ucenter/?url=',
  //试题中的图片url前缀
  QUESTION_IMG_URL: QUESTION_IMG_URL,
  CLIENT_MOBILE_WIDTH: 800,//移动端最大px宽度定义
  WSS_ADDRESS:"wss://test.hiyiba.com/ws/push",
}



// WEBPACK FOOTER //
// ./src/base/constants-dev.js